import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Layout, Row, Spin, Tooltip, Typography } from "antd";
import GreetingsTop from "../../../components/menu/greetings-top";
import { LeftOutlined } from "@ant-design/icons";

import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import ContractFilesList from "./list";
import { Contract, get } from "../../../api";

export default function Contracts() {
  const { Title } = Typography;
  const navigate = useNavigate();
  let { id } = useParams();
  const [contract, setContract] = useState<Contract | null>(null);
  const [loading, setLoading] = useState(true);

  const getContract = useCallback(async () => {
    if (!id) return;

    const httpContract = await get<Contract>(`/contracts/${id}`);
    if (httpContract.statusCode === 200) {
      setContract(httpContract.response);
    }
    setLoading(false);
  }, [id]);

  useEffect(() => {
    getContract();
  }, [getContract]);

  if (loading) {
    return <Spin tip="Cargando lista de archivos..." />;
  }

  return (
    <Layout>
      <GreetingsTop />
      <div className="catalog__container">
        <Row className="header-top">
          <Col xs={19} className="header-top__left">
            <Title
              level={3}
              style={{ top: 0, bottom: 0, height: "78%", margin: "auto" }}
            >
              {`Archivos de contrato ${contract?.contract_num}`}
            </Title>
          </Col>
          <Col xs={5}>
            <Row style={{ marginBottom: 30, justifyContent: "right" }}>
              <Tooltip title="Atrás">
                <Button
                  style={{ color: "gray", fontSize: 20, height: 0, width: 0 }}
                  type="link"
                  onClick={() => navigate("/contracts")}
                >
                  <LeftOutlined />
                </Button>
              </Tooltip>
            </Row>
          </Col>
        </Row>
      </div>
      <div className="catalog__container">
        {contract && <ContractFilesList contract = {contract}/>}
      </div>
    </Layout>
  );
}
